module.exports = __webpack_public_path__ + "static/img/322_TO8_2499.e13044d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/322_TO8_2499.jpg
// module id = MMnp
// module chunks = 0